var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('h3',[_vm._v(" Feature Usage ")]),_c('p',[_vm._v(" Which map features are the most popular among passengers? ")]),_c('div',{staticClass:"bar-chart-holder"},[_c('HorizontalBarChart',{staticClass:"bar-chart",attrs:{"label":"Active passengers","item-data":_vm.itemData,"width":600,"height":300}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }